import {
  PortalClassMediaBasic,
  PortalClassStateOrMedia,
  PortalColorSchemas,
  ThemeColorSchemas,
  ThemeColors,
} from '@nx-frontend/shared/types';

export function getThemeColorsBySchema(themeColors: ThemeColorSchemas, schema: PortalColorSchemas): ThemeColors {
  return themeColors[themeColors.findIndex((item) => item.schema === schema)].colors;
}

export function getClassNamePrefix(states: PortalClassStateOrMedia[] = []): string {
  return states.map((prefix) => (prefix !== PortalClassMediaBasic.BASE ? `${prefix}:` : '')).join('');
}

export function getColorSchemaPrefix(schema: PortalColorSchemas): string {
  return schema === PortalColorSchemas.DARK ? `dark:` : '';
}
